import { type Framework } from '@toeverything/infra';

import { WorkspaceServerService } from '../cloud/services/workspace-server';
import { WorkspaceDBService } from '../db';
import { FolderStore } from '../organize/stores/folder';
import { WorkspaceScope, WorkspaceService } from '../workspace';
import { FolderShareService } from './services/folder-share';

export type {
  FolderSharePolicy,
  FolderShareResult,
} from './services/folder-share';
export { FolderShareService } from './services/folder-share';

export function configureFolderShareModule(framework: Framework) {
  framework
    .scope(WorkspaceScope)
    .service(FolderShareService, [
      FolderStore,
      WorkspaceDBService,
      WorkspaceServerService,
      WorkspaceService,
    ]);
}
